import React from 'react';
import T from 'i18n-react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
  new: {
    color: '#FFF',
    borderRadius: 16,
    backgroundColor: '#EA3729',
    fontSize: 11,
    marginRight: 4,
    padding: '4px 10px',
  },
}));

const New = () => {
  const classes = useStyles();

  return <span className={classes.new}>{T.translate('new')}</span>;
};

export default New;
